module.exports = __webpack_public_path__ + "static/media/feature.8a9ad884.png";